import init from '../config/init'
import { vsprintf } from 'sprintf-js'

export default {
  methods: {
    trans (message) {
      const localmessage = message.split('.').reduce((o, i) => o[i], init.lang[init.language])
      const args = Array.prototype.slice.call(arguments)
      args.splice(0, 1)
      if (args.length > 0) return vsprintf(localmessage, args)
      return localmessage
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/lang.js